/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  KillswitchConflictName,
  KillswitchConflictName$inboundSchema,
} from "../components/killswitchconflictname.js";
import { GramError } from "./gramerror.js";

export type KillswitchConflictData = {
  message: string;
  name: KillswitchConflictName;
};

export class KillswitchConflict extends GramError {
  /** The original data that was passed to this error instance. */
  data$: KillswitchConflictData;

  constructor(
    err: KillswitchConflictData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "KillswitchConflict";
  }
}

/** @internal */
export const KillswitchConflict$inboundSchema: z.ZodMiniType<
  KillswitchConflict,
  unknown
> = z.pipe(
  z.object({
    message: z.string(),
    name: KillswitchConflictName$inboundSchema,
    request$: z.custom<Request>(x => x instanceof Request),
    response$: z.custom<Response>(x => x instanceof Response),
    body$: z.string(),
  }),
  z.transform((v) => {
    return new KillswitchConflict(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  }),
);
